import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseMiniIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { TYPE_EXACT_STRING, TYPE_INCLUSIVE_STRING } from './constants';
const ruleTypeLabel = type => {
  switch (type) {
    case TYPE_INCLUSIVE_STRING:
      return I18n.t('publisher.event_type_editor.sections.available_hours.bookable_events.meeting_name_includes');
    case TYPE_EXACT_STRING:
      return I18n.t('publisher.event_type_editor.sections.available_hours.bookable_events.meeting_name_is');
    default:
      return '';
  }
};
const containerCss = "c1i2ohz";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const textContentCss = "t9ygno";
const TextContent = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(textContentCss, props.className)} />);
export const Rule = ({
  rule,
  onEdit,
  onRemove
}) => {
  const handleEdit = () => {
    onEdit(rule.id);
  };
  const handleRemove = e => {
    e.stopPropagation();
    onRemove(rule.id);
  };
  return <Container role="group" aria-labelledby={`rule-${rule.id}`} data-component="meeting-exceptions-rule">
      <TextContent onClick={handleEdit} id={`rule-${rule.id}`}>
        <BodyText size="medium" weight="bold">{ruleTypeLabel(rule.type)}</BodyText>
        <BodyText>{rule.searchTerm}</BodyText>
      </TextContent>
      <IconButton title={I18n.t('publisher.action.remove')} onClick={handleRemove}>
        <CloseMiniIcon />
      </IconButton>
    </Container>;
};

require("./rule.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./rule.js");